module.exports = __webpack_public_path__ + "img/in-progress.679d1fce.svg";